export enum BillErrors {
	NotFound = 'NotFound'
}
